// NEURO QUEST — Les pouvoirs secrets de ton cerveau (phase 1 : 5 pouvoirs).
export const NQ_PHILOSOPHY = "On ne cherche pas à avoir un cerveau parfait. On cherche à découvrir comment utiliser au mieux les pouvoirs de son cerveau.";

export const NQ_LOOP = ["🎮 Jouer", "🧠 Découvrir", "🔎 Comprendre", "🛠️ Expérimenter", "🏠 Transférer dans la vie réelle", "⭐ Renforcer", "🚀 Gagner en autonomie"];

export const NQ_LEVELS = [
  { n: 1, name: "Apprenti", color: "#7CC6A6", desc: "Comprendre la règle" },
  { n: 2, name: "Explorateur", color: "#F2B84B", desc: "Maintenir la règle malgré les difficultés" },
  { n: 3, name: "Maître", color: "#E0705C", desc: "Combiner, inhiber, mémoriser ou s'adapter" },
];

export const NQ_SITUATIONS = [
  { id: "devoirs", emoji: "📚", label: "Devoirs" }, { id: "cartable", emoji: "🎒", label: "Cartable" }, { id: "ecole", emoji: "🏫", label: "École" },
  { id: "rangement", emoji: "🧹", label: "Rangement" }, { id: "repas", emoji: "🍽️", label: "Repas" }, { id: "soir", emoji: "🛏️", label: "Routine du soir" },
  { id: "jeux", emoji: "🎮", label: "Jeux" }, { id: "sport", emoji: "🏃", label: "Sport" }, { id: "famille", emoji: "👨‍👩‍👧", label: "Vie familiale" },
];

export const NQ_DIFFICULTY = [
  { id: "facile", emoji: "🟢", label: "Facile" },
  { id: "parfois", emoji: "🟠", label: "Parfois difficile" },
  { id: "difficile", emoji: "🔴", label: "Très difficile" },
];

export const NQ_XP = { mission: 1, debrief: 1, strategie: 1, transfert: 2 };

export const NQ_POWERS = [
  {
    id: "laser", emoji: "👁️", name: "L'Œil Laser", fn: "Attention sélective", world: "La Forêt des Distractions", worldEmoji: "🌲", color: "#3FA7A3",
    story: "Dans la forêt, tout bouge et tout brille. Seul l'Œil Laser sait repérer ce qui compte vraiment au milieu des distractions.",
    explain: "Ton attention sélective permet à ton cerveau de choisir ce qui est important et de laisser de côté ce qui peut te distraire.",
    did: ["trouver une information", "ignorer les autres", "garder la bonne règle", "rester concentré sur la cible"],
    manualKey: "concentrer",
    strategies: [
      { id: "zone", emoji: "🧹", name: "Nettoie ta zone", desc: "Ne garder visible que le matériel nécessaire." },
      { id: "cible", emoji: "🎯", name: "Une cible", desc: "Identifier une seule tâche à réaliser." },
      { id: "courte", emoji: "⏱️", name: "Mission courte", desc: "Travailler pendant une durée déterminée." },
      { id: "focus", emoji: "🎧", name: "Mode focus", desc: "Réduire les distractions sonores et numériques." },
      { id: "checklist", emoji: "📋", name: "Checklist", desc: "Externaliser ce qui doit être retenu." },
    ],
    transfer: "Pendant les devoirs, prépare ton espace et éloigne deux distractions.",
  },
  {
    id: "radar", emoji: "📡", name: "Le Radar", fn: "Attention soutenue", world: "La Tour du Radar", worldEmoji: "🗼", color: "#8B6FC0",
    story: "Du haut de la tour, l'explorateur surveille l'horizon. Le Radar l'aide à rester en alerte longtemps, même quand rien ne se passe.",
    explain: "Ton attention soutenue permet à ton cerveau de rester vigilant pendant un moment, pour ne pas rater ce qui est important.",
    did: ["rester attentif longtemps", "réagir seulement à la bonne cible", "résister à l'ennui et aux distracteurs", "garder la même précision jusqu'au bout"],
    manualKey: "saturer",
    strategies: [
      { id: "minuteur", emoji: "⏱️", name: "Le minuteur", desc: "Une durée courte et visible, puis une pause." },
      { id: "pause", emoji: "🧘", name: "Pause avant de saturer", desc: "Repérer le moment où l'attention décroche et bouger 2 minutes." },
      { id: "decoupe", emoji: "✂️", name: "Découpage", desc: "Une longue activité devient plusieurs petites missions." },
      { id: "mouvement", emoji: "🏃", name: "Mouvement", desc: "Alterner assis / debout pour recharger l'attention." },
    ],
    transfer: "Fais une activité pendant 10 minutes avec un minuteur et observe quand ton attention décroche.",
  },
  {
    id: "cristal", emoji: "💎", name: "Le Cristal Mémoire", fn: "Mémoire", world: "Les Grottes de la Mémoire", worldEmoji: "🪨", color: "#5E9BD6",
    story: "Au fond des grottes brillent des cristaux qui s'allument dans un ordre secret. Le Cristal Mémoire permet de retenir la séquence.",
    explain: "Ta mémoire permet à ton cerveau de garder des informations un moment, puis de les retrouver quand tu en as besoin.",
    did: ["observer attentivement", "garder l'ordre en tête", "répéter dans ta tête", "retrouver la séquence"],
    manualKey: "memoriser",
    strategies: [
      { id: "repeter", emoji: "🔁", name: "Répéter", desc: "Redire la liste plusieurs fois, à voix basse." },
      { id: "regrouper", emoji: "📦", name: "Regrouper", desc: "Faire des paquets de 2 ou 3 éléments." },
      { id: "visualiser", emoji: "🖼️", name: "Visualiser", desc: "Fabriquer une image mentale de ce qu'il faut retenir." },
      { id: "associer", emoji: "🔗", name: "Associer", desc: "Relier l'information à quelque chose que je connais déjà." },
      { id: "ecrire", emoji: "📝", name: "Écrire", desc: "Noter ce que je dois retenir : ma mémoire externe." },
    ],
    transfer: "Trouve une méthode pour retenir ta prochaine leçon et teste-la.",
  },
  {
    id: "stop", emoji: "🛡️", name: "Le Bouclier STOP", fn: "Inhibition", world: "Le Labyrinthe — zone Bouclier", worldEmoji: "🛑", color: "#E0705C",
    story: "Dans le labyrinthe, des pièges invitent à foncer sans réfléchir. Le Bouclier STOP arrête la réponse automatique juste à temps.",
    explain: "Ton inhibition permet à ton cerveau de freiner une réponse automatique pour choisir la bonne action.",
    did: ["freiner une réponse automatique", "regarder avant d'agir", "changer de règle quand elle s'inverse", "rester précis même en vitesse"],
    manualKey: "bloque",
    strategies: [
      { id: "stop3", emoji: "✋", name: "STOP → REGARDE → CHOISIS", desc: "Trois temps avant de répondre." },
      { id: "deux", emoji: "⏲️", name: "Deux secondes", desc: "Compter 2 secondes avant de répondre." },
      { id: "lire", emoji: "📖", name: "Lire jusqu'au bout", desc: "Lire toute la question avant de commencer." },
      { id: "ecrire", emoji: "✍️", name: "Écrire avant de dire", desc: "Noter la réponse avant de la donner." },
    ],
    transfer: "Avant de répondre impulsivement, fais STOP → REGARDE → CHOISIS.",
  },
  {
    id: "cameleon", emoji: "🦎", name: "Le Caméléon", fn: "Flexibilité cognitive", world: "Le Labyrinthe — zone Caméléon", worldEmoji: "🌈", color: "#F2B84B",
    story: "Le Caméléon change de couleur quand le décor change. Il sait abandonner une règle devenue inutile pour en adopter une nouvelle.",
    explain: "Ta flexibilité permet à ton cerveau de changer de stratégie quand la règle ou le programme change.",
    did: ["repérer que la règle a changé", "lâcher l'ancienne règle", "appliquer la nouvelle", "rester attentif aux changements"],
    manualKey: "changer",
    strategies: [
      { id: "planb", emoji: "🅱️", name: "Plan B", desc: "Quand ça change, je cherche une autre façon de faire." },
      { id: "annonce", emoji: "📣", name: "Annonce du changement", desc: "Demander qu'on me prévienne avant un changement." },
      { id: "respire", emoji: "🌬️", name: "Respirer puis regarder", desc: "Une respiration, puis observer la nouvelle règle." },
      { id: "question", emoji: "❓", name: "Quelle est la règle maintenant ?", desc: "Me poser la question à voix haute." },
    ],
    transfer: "Lorsque le programme change cette semaine, cherche un plan B.",
  },
  {
    id: "multitasker", emoji: "🔄", name: "Le Multitasker", fn: "Attention divisée", world: "La Cité des Deux Missions", worldEmoji: "🏙️", color: "#E0955C",
    story: "Dans la cité, deux missions se déroulent en même temps. Le Multitasker apprend à partager son attention… et découvre qu'il est parfois plus efficace de faire une chose après l'autre.",
    explain: "Ton cerveau possède des ressources limitées. Lorsque plusieurs choses demandent ton attention en même temps, certaines deviennent plus difficiles. Parfois, il est plus efficace de faire une chose après l'autre.",
    did: ["surveiller deux choses à la fois", "choisir ce qui est urgent", "revenir vite à la première tâche", "garder deux règles en tête"],
    manualKey: "distrait",
    strategies: [
      { id: "unechose", emoji: "1️⃣", name: "Une chose après l'autre", desc: "Terminer une action avant de commencer la suivante." },
      { id: "priorite", emoji: "🚦", name: "L'urgence d'abord", desc: "Repérer ce qui ne peut pas attendre, le faire, puis revenir." },
      { id: "poser", emoji: "📌", name: "Poser un repère", desc: "Noter où j'en suis avant d'être interrompu." },
      { id: "couper", emoji: "🔕", name: "Couper la deuxième source", desc: "Écran éteint ou musique coupée pendant la tâche principale." },
    ],
    transfer: "Pendant une activité, repère un moment où deux choses te demandent de l'attention et choisis de les faire l'une après l'autre.",
  },
  {
    id: "carte", emoji: "🗺️", name: "La Carte du Maître", fn: "Planification", world: "Le Labyrinthe — zone Carte", worldEmoji: "🧭", color: "#5E9BD6",
    story: "Le Maître ne fonce jamais tête baissée : il trace le chemin sur sa carte, étape par étape, avant de partir à l'aventure.",
    explain: "Ta planification permet à ton cerveau d'organiser les étapes dans le bon ordre avant d'agir, pour ne rien oublier et éviter les pièges.",
    did: ["réfléchir avant d'agir", "mettre les étapes dans l'ordre", "tenir compte des contraintes", "changer le plan en cas d'imprévu"],
    manualKey: "organiser",
    strategies: [
      { id: "etapes", emoji: "🪜", name: "Découper en étapes", desc: "Écrire 3 à 5 étapes avant de commencer." },
      { id: "ordre", emoji: "🔢", name: "Numéroter", desc: "Mettre un numéro devant chaque étape." },
      { id: "materiel", emoji: "🧰", name: "Préparer le matériel", desc: "Rassembler ce qu'il faut avant de démarrer." },
      { id: "planb", emoji: "🅱️", name: "Prévoir un plan B", desc: "Imaginer ce que je ferai si quelque chose bloque." },
    ],
    transfer: "Prépare ton sac en organisant les étapes avant de commencer.",
  },
  {
    id: "start", emoji: "🚀", name: "Booster START", fn: "Initiation", world: "Le Labyrinthe — zone Booster", worldEmoji: "🛸", color: "#7CC6A6",
    story: "Devant une grande mission, l'explorateur reste parfois figé. Le Booster START trouve la toute première petite étape et passe de l'intention à l'action.",
    explain: "Ton initiation permet à ton cerveau de démarrer : trouver par quoi commencer et faire le premier pas, même quand la mission paraît énorme.",
    did: ["repérer la plus petite première étape", "éviter les étapes trop vagues ou trop grandes", "enchaîner avec l'étape suivante", "passer de l'intention à l'action"],
    manualKey: "commencer",
    strategies: [
      { id: "petite", emoji: "🐾", name: "La plus petite étape", desc: "« Quelle est la plus petite chose que je peux faire maintenant ? »" },
      { id: "premiere", emoji: "1️⃣", name: "Première étape évidente", desc: "Prendre le cahier, l'ouvrir à la bonne page." },
      { id: "cinq", emoji: "⏱️", name: "Règle des 5 minutes", desc: "Commencer seulement 5 minutes, puis décider." },
      { id: "avecmoi", emoji: "🤝", name: "Démarrer avec quelqu'un", desc: "Faire la première étape avec un adulte, puis continuer seul." },
    ],
    transfer: "Devant tes devoirs, dis à voix haute la plus petite première étape et fais-la tout de suite.",
  },
  {
    id: "scanner", emoji: "🔍", name: "Le Scanner", fn: "Vérification / contrôle", world: "Le Labyrinthe — zone Scanner", worldEmoji: "🛰️", color: "#8B6FC0",
    story: "Avant de quitter le labyrinthe, le Scanner passe tout en revue : STOP → SCAN → CORRIGE → TERMINE.",
    explain: "Ta vérification permet à ton cerveau de relire et contrôler son travail avant de dire « terminé », pour repérer et corriger les petites erreurs.",
    did: ["résister à l'envie de valider tout de suite", "comparer avec le modèle", "repérer les différences", "corriger avant de terminer"],
    manualKey: "organiser",
    strategies: [
      { id: "scan", emoji: "🔍", name: "STOP → SCAN → CORRIGE → TERMINE", desc: "Quatre temps avant de rendre." },
      { id: "checklist", emoji: "📋", name: "Checklist de vérification", desc: "Nom, consigne relue, réponses complètes, cartable fermé." },
      { id: "doigt", emoji: "👆", name: "Suivre avec le doigt", desc: "Relire ligne par ligne en suivant avec le doigt." },
      { id: "modele", emoji: "🪞", name: "Comparer au modèle", desc: "Mettre le modèle à côté et comparer élément par élément." },
    ],
    transfer: "Avant de fermer ton cartable ou de rendre un travail, fais un SCAN de 30 secondes et corrige une chose.",
  },
  {
    id: "combo", emoji: "🏰", name: "Les Super-Combos", fn: "Pouvoirs combinés", world: "Le Royaume des Super-Combos", worldEmoji: "⚡", color: "#B58C67", advanced: true,
    story: "Au Royaume, les pouvoirs se combinent : mémoriser, sélectionner, planifier, vérifier… Une seule mission mobilise plusieurs pouvoirs à la fois.",
    explain: "Dans la vraie vie, ton cerveau combine ses pouvoirs : l'attention et la mémoire font FOCUS, la planification et la flexibilité font STRATÈGE. Les combos, c'est utiliser plusieurs pouvoirs pour une même mission.",
    did: ["mémoriser une liste", "sélectionner les bons éléments parmi les distracteurs", "planifier les étapes", "vérifier avant de terminer"],
    manualKey: "organiser",
    strategies: [
      { id: "liste", emoji: "📝", name: "Liste + vérification", desc: "Écrire la liste, puis la cocher à la fin." },
      { id: "ordre", emoji: "🗺️", name: "Plan en 3 étapes", desc: "Préparer → faire → vérifier." },
      { id: "focus", emoji: "🎯", name: "Mode FOCUS", desc: "Une seule cible, environnement nettoyé, mémoire externe." },
      { id: "planb", emoji: "🅱️", name: "Plan B prêt", desc: "Savoir quoi faire si l'imprévu arrive." },
    ],
    transfer: "Prépare une sortie ou ton cartable en combinant : liste → sélection → ordre → vérification.",
  },
];

export const NQ_COMBOS = [
  { id: "focus", name: "FOCUS", parts: "Attention + mémoire", emoji: "🎯" },
  { id: "controle", name: "CONTRÔLE", parts: "Mémoire de travail + inhibition", emoji: "🛡️" },
  { id: "stratege", name: "STRATÈGE", parts: "Planification + flexibilité", emoji: "🧠" },
  { id: "booster", name: "BOOSTER", parts: "Initiation + planification", emoji: "🚀" },
];

export const NQ_MANUAL = [
  { key: "concentrer", label: "Quand je dois me concentrer" },
  { key: "memoriser", label: "Quand je dois mémoriser" },
  { key: "commencer", label: "Quand je dois commencer" },
  { key: "distrait", label: "Quand je suis distrait" },
  { key: "bloque", label: "Quand je suis bloqué" },
  { key: "changer", label: "Quand je dois changer de programme" },
  { key: "organiser", label: "Quand je dois m'organiser" },
  { key: "saturer", label: "Quand je sens que je commence à saturer" },
];

export const NQ_PARENT_ROLES = [
  { emoji: "🧭", r: "Le coach", d: "Il aide l'enfant à observer." },
  { emoji: "🕵️", r: "Le co-détective", d: "Il cherche avec lui ce qui facilite ou complique." },
  { emoji: "🧪", r: "Le scientifique", d: "Il participe aux expériences." },
  { emoji: "🏆", r: "Le coéquipier", d: "Il renforce les progrès." },
  { emoji: "👑", r: "Le garant du cadre", d: "L'adulte conserve la décision finale sur règles, objectifs et renforcements." },
];

export const NQ_PHASE2 = ["🔄 Le Multitasker (attention divisée)", "🗺️ La Carte du Maître (planification)", "🚀 Booster START (initiation)", "🔍 Le Scanner (vérification)", "🏰 Le Royaume des Super-Combos"];
